import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, RepresentativeModalForm, useShowToast } from "@madmedical/ui";
import { ApiFormWrapper } from "@madmedical/form";
import { useInviteMutation } from "../api";
const InviteModal = ({ open, onClose }) => {
    const [invite] = useInviteMutation();
    const showToast = useShowToast();
    const handleSuccess = () => {
        showToast("Meghívó kiküldve.", { variant: "success" });
    };
    return (_jsx(Modal, Object.assign({ open: open, size: "sm", onClose: onClose }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: { email: "", note: "" }, mutation: invite, onSuccess: handleSuccess, resetOnSuccess: true }, { children: ({ submitForm, isSuccess }) => (_jsx(RepresentativeModalForm, { mode: "invite", onClose: onClose, onSubmitPress: submitForm, isSuccess: isSuccess })) })) })));
};
export default InviteModal;
